module.exports = __webpack_public_path__ + "static/media/logo-wave.7a93ac1c.png";